<template>
  <div id="v-admin-frame">
    <div class="admin-sidebar">
      <router-link class="admin-sidebar-profile" to="/dashboard" style="margin-top: 0" title="Change Collectives"></router-link>
      <router-link class="admin-sidebar-item" to="./upload" title="Upload"><i class="material-icons">file_upload</i></router-link>
      <hr>
      <router-link class="admin-sidebar-item" to="./dashboard" title="Dashboard"><i class="material-icons">dashboard</i></router-link>
      <router-link class="admin-sidebar-item" to="./images" title="Images"><i class="material-icons">image</i></router-link>
      <!--<router-link class="admin-sidebar-item" to="./services" title="Services"><i class="material-icons">local_atm</i></router-link>
      <router-link class="admin-sidebar-item" to="./followers" title="Followers"><i class="material-icons">person_pin</i></router-link>-->
      <router-link class="admin-sidebar-item" to="./widgets" title="Support"><i class="material-icons">device_hub</i></router-link>
      <!--<hr>
      <router-link class="admin-sidebar-item" to="./general" title="General"><i class="material-icons">settings</i></router-link>
      <router-link class="admin-sidebar-item" to="./members" title="Members"><i class="material-icons">group</i></router-link>
      <router-link class="admin-sidebar-item" to="./policies" title="Policies"><i class="material-icons">copyright</i></router-link>-->
    </div>
    <div class="v-admin-default-container" style="text-align: left;">
      <div class="admin-header-headings">
        <h5>{{collective.fullname}}</h5>
        <h2>{{currentRouteName}}</h2>
      </div>
      <transition name="slide-fade" mode="out-in">
        <router-view :collective="collective"></router-view>
      </transition>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import matcher from './Matcher'

export default {
  props: ['slug'],
  computed: {
    ...mapGetters([
      'allCollectives'
    ]),
    collective: function () {
      if (!this.allCollectives['@' + this.slug]) {
        this.$store.dispatch('fetchCollective', this.slug)
        return {}
      }
      return this.allCollectives['@' + this.slug]
    },
    currentRouteName: function () {
      return matcher(this.$route.name).name
    }
  }
}
</script>
<style lang="scss">

.admin-header-headings {
  text-align: left;
  h2 {
    font-size: 2em;
    margin: 5px 0;
    font-weight: 600;
  }
  h5 {
    font-size: 1em;
    font-weight: 400;
    color: #666;
    margin: 5px 0;
  }
}

.admin-sidebar {
  position: fixed;
  top: 90px;
  left: calc(50% - 520px);
  z-index: 100;

  .admin-sidebar-profile, .admin-sidebar-item {
    background-color: transparent;
    color: #777;
    display: block;
    width: 50px;
    height: 50px;
    border-radius: 30px;
    margin: 16px auto;
    transition: 150ms ease;
    position: relative;
    padding: 8px 0;
    text-align: center;
    box-sizing: border-box;

    &:hover {
      background-color: #ddd;
      color: #555;
      cursor: pointer;
      transition: 150ms ease;
    }

    &:after {
      content: attr(title);
      background-color: #3e3e3e;
      color: #eee;
      font-size: 12px;
      position: absolute;
      right: 80px;
      top: 8px;
      max-width: 120px;
      width: auto;
      height: auto;
      padding: 6px 10px;
      cursor: default;
      opacity: 0;
      transition: 300ms ease;
      border-radius: 0;
      font-weight: 400;
    }

    &:hover:after {
      right: 60px;
      opacity: 1;
      transition: 300ms ease;
    }

    &.router-link-exact-active {
      background-color: #444;
      color: #eee;
    }
  }

  .admin-sidebar-profile {
    background-color: #efefef;
  }

  .admin-sidebar-item {
    width: 40px;
    height: 40px;

    &:hover:after {
      right: 54px;
    }
  }

  hr {
    color: #fff;
    background-color: #fff;
  }
}

.v-admin-default-container {
  top: 60px;
  left: calc(50% - 420px);
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/AdminFrame.vue